namespace $ { $mol_style_attach( "bog/gamengine/studio/studio.view.css",
 "[bog_gamengine_studio_drop][bog_gamengine_studio_placing=\"true\"] {\n\tcursor: copy;\n}\n\n[bog_gamengine_studio_source_foot] {\n\tflex-wrap: wrap;\n}\n\n[bog_gamengine_studio_source_foot] > * {\n\tflex: 1 1 8rem;\n\tmin-width: 0;\n}\n"
) }